import Kanban from './Kanban';
import * as decorators from './decorators';

export {
  decorators,
  Kanban as VirtualKanban
};



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/